<!-- eslint-disable max-len -->
<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.775,11.293l-2.463-.7a.5.5,0,0,1-.358-.41L6.747,8.726A3,3,0,0,0,8.5,6V4.626A3.084,3.084,0,0,0,5.592,1.5,3,3,0,0,0,2.5,4.5V6A3,3,0,0,0,4.253,8.726l-.207,1.453a.5.5,0,0,1-.358.41l-2.463.7a1,1,0,0,0-.725.961V14.5h10V12.254A1,1,0,0,0,9.775,11.293Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5,14.5h3V11.281a1,1,0,0,0-.757-.97l-2.917-.729a.5.5,0,0,1-.374-.415l-.205-1.441A3,3,0,0,0,13,5V3.626A3.084,3.084,0,0,0,10.092.5,3,3,0,0,0,8.5.9"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
